import { Card, Typography, Spin, Button } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { getCoupons, removeDiscount } from '@/api/user';
import { GiftOutlined, PlusOutlined } from '@ant-design/icons';
import CouponRedemption from '@/components/SubscriptionComponents/CouponRedemption';
import RenderCouponInfo from '@/components/SubscriptionComponents/RenderCouponInfo/RenderCouponInfo';
import { applyCouponCode } from '@/api/user';
import { getLoggedInUser } from '@/store/account/selector';
import { useAppSelector } from '@/store/hooks/useAppSelector';
import { setCurrentPage } from '@/store/account/slice';
import { UserDashboardSiderItem } from 'src/enums/EUserDashboardSiderItem';
import { useAppDispatch } from '@/store/hooks/useAppDispatch';

const { Text } = Typography;

const ManageUsage = () => {
	const dispatch = useAppDispatch();
	const loggedInUser = useAppSelector(getLoggedInUser);
	const { data, isLoading, refetch } = useQuery({
		queryKey: ['coupons'],
		queryFn: () => getCoupons('Client'),
		enabled: Boolean(
			(!!loggedInUser?.inboundSubscriptionId &&
				loggedInUser?.inboundSubscriptionStatus !== 'canceled') ||
				(!!loggedInUser?.outboundSubscriptionId &&
					loggedInUser?.outboundSubscriptionStatus !== 'canceled'),
		),
	});

	const handleSubscribeNow = () => {
		dispatch(setCurrentPage(UserDashboardSiderItem.SUBSCRIPTION));
	};

	return (
		<div className="p-8 max-w-5xl mx-auto">
			<Spin spinning={isLoading}>
				<div className="relative">
					{/* Add overlay when there's no subscription */}
					{((!loggedInUser?.inboundSubscriptionId && !loggedInUser?.outboundSubscriptionId) ||
						(loggedInUser?.inboundSubscriptionStatus === 'canceled' &&
							loggedInUser?.outboundSubscriptionStatus === 'canceled')) && (
						<div className="absolute inset-0 bg-white/80 backdrop-blur-sm z-10 rounded-lg" />
					)}

					<Card
						className="shadow-sm hover:shadow-md transition-all duration-300"
						title={
							<div className="flex items-center">
								<GiftOutlined className="text-purple-500 mr-2" />
								<Text strong>Promotional Credits</Text>
							</div>
						}
					>
						<div className="space-y-4">
							<div className="bg-gray-50 p-4 rounded-lg">
								<RenderCouponInfo
									appliedCoupons={data?.data?.appliedCoupons as any}
									onUpdate={refetch}
									removeDiscount={removeDiscount}
								/>
							</div>

							<div className="mt-6">
								<CouponRedemption updateSuccess={refetch} applyCouponCode={applyCouponCode} />
							</div>
						</div>
					</Card>

					{/* Add subscription message when there's no subscription */}
					{((!loggedInUser?.inboundSubscriptionId && !loggedInUser?.outboundSubscriptionId) ||
						(loggedInUser?.inboundSubscriptionStatus === 'canceled' &&
							loggedInUser?.outboundSubscriptionStatus === 'canceled')) && (
						<div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20 text-center">
							<div className="bg-white p-8 rounded-lg shadow-lg max-w-lg">
								<h3 className="text-xl font-semibold text-gray-800 mb-4">No Active Subscription</h3>
								<p className="text-gray-600 mb-6">
									Subscribe to our plans to access promotional credit features and start using our
									services.
								</p>
								<div className="flex justify-center gap-4">
									<Button
										type="primary"
										size="large"
										onClick={handleSubscribeNow}
										icon={<PlusOutlined />}
									>
										Subscribe Now
									</Button>
								</div>
							</div>
						</div>
					)}
				</div>
			</Spin>
		</div>
	);
};

export default ManageUsage;
